<div class="d-lg-flex justify-content-between">
  <div>
    <div class="mb-3">
      <span class="text-bold me-2"
            [translate]="headerTranslateKey"></span>

      <i class="icon-pencil pointer text-blue-2 me-2 lh-1"
         *ngIf="showDeliveryEdit"
         (click)="onDeliveryEdit.emit()"></i>


      <ui-order-line-status-badge
        *ngIf="deliveryOrder.state === ORDER_LINE_STATES.EDITED"
        [status]="deliveryOrder.state"
      ></ui-order-line-status-badge>
    </div>

    <table class="font-md">
      <tr *ngIf="deliveryOrder.deliveryUserName">
        <td class="text-muted pe-3" [translate]="'receipt.recipient'"></td>
        <td>{{deliveryOrder.deliveryUserName}}</td>
      </tr>

      <tr *ngIf="deliveryOrder.deliveryPhone">
        <td class="text-muted pe-3" [translate]="'receipt.contactPhone'"></td>
        <td>{{deliveryOrder.deliveryPhone}}</td>
      </tr>

      <tr>
        <td class="text-muted pe-3">
          <span [translate]="'common.delivery.deliveryAddress'"></span>:
        </td>

        <td>
          {{deliveryOrder.deliveryAddress}}
          ,&nbsp;{{deliveryOrder.deliveryPostNumber}}&nbsp;{{deliveryOrder.deliveryCity}}
        </td>
      </tr>

      <tr *ngIf="deliveryOrder.deliveryDate && deliveryOrder.deliveryTime">
        <td class="text-muted pe-3">
          <span [translate]="'common.delivery.deliveryTime'"></span>:
        </td>

        <td>
          <span class="first-letter-capitalize d-inline-block">
            {{deliveryOrder.deliveryDate | i18nDate : 'dddd D MMM'}}
          </span>
          {{deliveryOrder.deliveryTime}}
        </td>
      </tr>

      <tr *ngIf="deliveryOrder.deliveryNote">
        <td class="text-muted pe-3" [translate]="'receipt.messageToDriver'"></td>
        <td>{{deliveryOrder.deliveryNote}}</td>
      </tr>
    </table>
  </div>

  <div class="mt-md-max-3">
    <ng-content></ng-content>
  </div>
</div>
